import { Component, Inject, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@Component({
  selector: 'app-language-toggle-button',
  templateUrl: './language-toggle-button.component.html',
  styleUrl: './language-toggle-button.component.css'
})
export class LanguageToggleButtonComponent {
  btnLangText = 'Ar';
  currentLang: any;
  direction: 'rtl.css' | 'ltr.css';

  constructor(
    private localization: LocalizationService,
    @Inject(DOCUMENT) private document: Document
  ) { }

  ngOnInit(): void {
    const lang = this.localization.getCachedLanguage()?.toLowerCase();
    if (lang === 'ar') {
      this.btnLangText = 'En';
      this.applyDirection('ar');
    }
  }

  toggleLanguage(): void {
    const newLang = this.btnLangText === 'Ar' ? 'ar' : 'en';
    this.btnLangText = this.btnLangText === 'Ar' ? 'En' : 'Ar';
    this.applyDirection(newLang);
  }

  private applyDirection(lang: string): void {
    this.localization.switchLanguage(lang);
    this.currentLang = this.localization.currentLanguage(lang);
    const styleId = 'direction-style';
    const head = this.document.head;
    let themeLink = this.document.getElementById(styleId) as HTMLLinkElement;

    this.direction = this.currentLang.isRightToLeft ? 'rtl.css' : 'ltr.css';
    if (themeLink) {
      themeLink.href = this.direction;
    } else {
      themeLink = this.document.createElement('link');
      themeLink.id = styleId;
      themeLink.rel = 'stylesheet';
      themeLink.href = this.direction;
      head.appendChild(themeLink);
    }

    const html = this.document.documentElement;
    html.dir = this.currentLang.isRightToLeft ? 'rtl' : 'ltr';
    this.document.body.dir = html.dir;
  }
}
